import React from 'react'
import { useNavigate } from 'react-router-dom'
import { navigation_constants } from '../constants/navigation.constants'

const JoinBetaSuccessPage = () => {
    const navigate = useNavigate()
    
    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            textAlign: "center",
            transform: "translateY(-10%)", // Lifts the content up slightly
            // maxWidth: "600px", // Maximum width
            // margin: "0 auto", // Ensures the div stays centered horizontally
            marginLeft: "30px",
            marginRight: "30px"
            }}>
            <h1 style={{ fontWeight: "bold" }}>Registration Successful</h1>
            <div style={{height: "10px"}} />
            <ul style={{ textAlign: "left" }}>
                <li style={{color: "grey"}}>An invite link will be sent to your email or whatsApp <b style={{color:"black"}}>after a few hours or days</b>.</li>
                <li style={{color: "grey"}}>Open the link <b style={{color:"black"}}>on your android device</b> and accept the invitation</li>
                <li style={{color: "grey"}}>After accepting, click the download link in the invitation, which leads to the play store, to download</li>
            </ul>
            <div style={{height: "10px"}} />
            <button onClick={()=> navigate(navigation_constants.pages.home)} className="primary-button">Continue</button>
        </div>
    );
}

export default JoinBetaSuccessPage